import { createMemo } from "solid-js"
import type { EntityGraphNode } from "../../lib/core/engine/EntityGraphNode/EntityGraphNode.type"
import isEntityUnit from "../../lib/core/entity/isEntityUnit"
import type { UnitEntityUnion } from "../../lib/core/entity/UnitEntityUnion.type"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedEntityGraphNodeListMemo } from "./createSharedEntityGraphNodeListMemo"

// return all Unit ents
export const useSharedUnitEntsListMemo = createSharedCachedFactory((engine) => {

  const getEntityGraphNodeList = createSharedEntityGraphNodeListMemo(engine)

  const getUnitEntsList = createMemo<Array<EntityGraphNode<UnitEntityUnion>>>(() => {
    const list: Array<EntityGraphNode<UnitEntityUnion>> = getEntityGraphNodeList().filter(isEntityUnit) as Array<EntityGraphNode<UnitEntityUnion>>
    return list
  }, [], {
    equals: isIdListSame,
  })

  // createEffect(() => {
  //   console.log('getUnitEntsList', getUnitEntsList())
  // })

  return getUnitEntsList
})
